export default "__VITE_ASSET__hcNxvNE7__"